import { FC, useEffect } from 'react';

import Policy from '../../components/Desktop/Policy';

/** Privacy policy page backed by Termageddon-hosted content. */
const Privacy: FC = () => {
  useEffect(() => {
    document.title = 'HomeCook | Privacy Policy';
  }, []);

  return (
    <div className="flex h-[900px] flex-col justify-start overflow-y-auto sm:h-screen">
      <p className="text-md mx-auto mt-[90px] font-raleway font-semibold text-primaryDark-200">
        Privacy Policy
      </p>
      <div className="mx-auto w-11/12 font-open-sans font-medium">
        <Policy policyKey={process.env.REACT_APP_PRIVACY_POLICY_KEY} />
      </div>
    </div>
  );
};

export default Privacy;
